import React from "react";
import { useTranslation as useI18nextTranslations } from "react-i18next";
import { LocaleRepo } from "./TranslationContext";

export const useTranslationsRepoDefault = (localeStrings: any): LocaleRepo => {
  return useTranslationsRepo(localeStrings, "website2.website");
};

export const useTranslationsRepoForMobile = (localeStrings: any): LocaleRepo => {
  return useTranslationsRepo(localeStrings, "mobile_web");
};

const useTranslationsRepo = (localeStrings: any, forBuildType: string): LocaleRepo => {
  const { t, i18n } = useI18nextTranslations(forBuildType);
  const getValue = (path: string, subs?: Record<string, string>) => t(`${forBuildType}:${path}`, subs);

  const getCurrentLocale = () => i18n.language;

  return {
    getValue,
    getCurrentLocale,
    getLanguages: () => localeStrings.allLanguages,
  };
};
